export const Tiers1 = [
	{
		startStep: 1,
		endStep: 30,
	},
	{
		startStep: 31,
		endStep: 60,
	},
	{
		startStep: 61,
		endStep: 90,
	},
]
export const Tiers2 = [
	{
		startStep: 1,
		endStep: 50,
	},
	{
		startStep: 51,
		endStep: 100,
	},
]
